import React from 'react';
import { ShieldCheck, FileText, Lock, Database } from 'lucide-react';
import { SECURITY_FEATURES, SECURITY_HEADER } from '../constants';
import { useLanguage } from '../LanguageContext';

const ICON_MAP = {
  ShieldCheck: <ShieldCheck size={20} />,
  FileText:    <FileText size={20} />,
  Lock:        <Lock size={20} />,
  Database:    <Database size={20} />,
};

export default function Security() {
  const { lang }   = useLanguage();
  const features   = SECURITY_FEATURES[lang];
  const header     = SECURITY_HEADER[lang];

  return (
    <section className="pb-section pb-section-pad" id="securite" data-testid="pb-security">
      <div className="pb-container">
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 64, alignItems: 'center' }}>
          {/* Left */}
          <div>
            <div className="pb-label">{header.label}</div>
            <h2 className="pb-section-title">
              {header.title.split('\n').map((line, i) => (
                <React.Fragment key={i}>{line}{i === 0 && <br />}</React.Fragment>
              ))}
            </h2>
            <p className="pb-section-sub" style={{ marginTop: 16, marginBottom: 32 }}>{header.sub}</p>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
              {header.badges.map(badge => (
                <span key={badge} style={{
                  display: 'inline-flex', alignItems: 'center', gap: 6,
                  fontSize: 12, fontWeight: 600,
                  background: 'rgba(0,85,164,0.06)', color: 'var(--pb-france-blue)',
                  padding: '5px 12px', borderRadius: 9999,
                  border: '1px solid rgba(0,85,164,0.12)',
                }}>
                  {badge}
                </span>
              ))}
            </div>
          </div>

          {/* Right */}
          <div className="pb-security-grid">
            {features.map(feat => (
              <div key={feat.title} className="pb-security-card" data-testid={`pb-security-${feat.icon.toLowerCase()}`}>
                <div className="pb-security-icon" aria-hidden="true">{ICON_MAP[feat.icon]}</div>
                <div className="pb-security-title">{feat.title}</div>
                <p className="pb-security-desc">{feat.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) {
          #securite .pb-container > div {
            grid-template-columns: 1fr !important;
            gap: 40px !important;
          }
        }
      `}</style>
    </section>
  );
}
